import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CircularProgress from "../../../utils/CircularProgress";
import PerformanceLineChart from "../../../utils/PerformanceLineChart";
import "./jobInsightsV2.scss";

// SAMPLE / PREVIEW ONLY — all data below is mocked so the UI can be reviewed
// before wiring it up to real endpoints.

const MOCK_LABELS = ["10-Sep", "11-Sep", "12-Sep", "13-Sep", "14-Sep", "15-Sep", "16-Sep"];

const MOCK_CHART_DATA = {
  labels: MOCK_LABELS,
  series: [
    { label: "Candidate - Created", data: [2, 4, 3, 6, 5, 8, 7] },
    { label: "AI Telephonic Screening - Completed", data: [1, 2, 2, 3, 4, 5, 4] },
    { label: "AI Video Interviews - Completed", data: [0, 1, 1, 2, 3, 3, 4] },
    { label: "AI Candidate Assessments - Completed", data: [1, 1, 2, 2, 3, 4, 5] },
  ],
};

const MOCK_STAGES = [
  { key: "applied", label: "Applied", count: 128, color: "#F5A623" },
  { key: "screening", label: "Telephonic Screening", count: 86, color: "#0048B7" },
  { key: "video", label: "Video Interview", count: 54, color: "#00DDFF" },
  { key: "assessment", label: "Assessment", count: 37, color: "#FF1C58" },
  { key: "Hired", label: "Hired", count: 12, color: "#4CC948" },
];

const MOCK_FEED = [
  { id: 1, time: "2 hours ago", text: "Ravi Kumar completed the AI Video Interview.", icon: "/images/video-player-black.svg", bg: "#00DDFF1A" },
  { id: 2, time: "5 hours ago", text: "3 candidates were invited to Telephonic Screening.", icon: "/images/circle-phone-black.svg", bg: "#0048B71A" },
  { id: 3, time: "1 day ago", text: "Priya Sharma scored 92% in Candidate Assessment.", icon: "/images/user-check-black.svg", bg: "#FF1C581A" },
  { id: 4, time: "2 days ago", text: "5 new candidates applied to this job.", icon: "/images/person-plus-black.svg", bg: "#FFC8571A" },
];

const JobInsightsV2 = () => {
  const [dateRange, setDateRange] = useState([moment().subtract(6, "days").toDate(), new Date()]);
  const [startDate, endDate] = dateRange;

  const totalApplied = MOCK_STAGES[0]?.count || 0;
  const maxStageCount = Math.max(...MOCK_STAGES.map((s) => s.count));

  return (
    <div className="job-insights-v2">
      <div className="job-insights-stats">
        <div className="job-insights-stats-top">
          <h4>Performance stats</h4>
          <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => setDateRange(update)}
            isClearable={true}
            dateFormat="dd MMM"
            className="form-control date-range-picker"
            placeholderText="Select date range"
          />
        </div>

        <div className="job-insights-stats-body row">
          <div className="job-insights-chart col-lg-8 col-12">
            <PerformanceLineChart chartData={MOCK_CHART_DATA} />
          </div>
          <div className="job-insights-rings col-lg-4 col-12">
            <div className="job-insights-rings-grid">
              <div className="ring-item">
                <h5>Telephonic <br /> Screening</h5>
                <CircularProgress percentage={72} strokeColor="#0048b7" icon="/images/circle-phone-black.svg" value={86} label="Scheduled" />
                <h6 style={{ color: "#0048B7" }}>62 Completed</h6>
              </div>
              <div className="ring-item">
                <h5>Video <br /> Interviews</h5>
                <CircularProgress percentage={64} strokeColor="#00DDFF" icon="/images/video-player-black.svg" value={54} label="Assigned" />
                <h6 style={{ color: "#00DDFF" }}>35 Completed</h6>
              </div>
              <div className="ring-item">
                <h5>Candidate <br /> Assessments</h5>
                <CircularProgress percentage={58} strokeColor="#FF1C58" icon="/images/user-check-black.svg" value={37} label="Assigned" />
                <h6 style={{ color: "#FF1C58" }}>21 Completed</h6>
              </div>
              <div className="ring-item">
                <h5>Candidate <br /> Engagement</h5>
                <CircularProgress percentage={81} strokeColor="#FFC857" icon="/images/person-plus-black.svg" value={128} label="Applied" />
                <h6 style={{ color: "#FFC857" }}>104 Engaged</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="job-insights-row">
        <div className="job-insights-card job-insights-funnel">
          <div className="job-insights-card-head">
            <h4>Hiring funnel</h4>
            <span className="job-insights-card-sub">{totalApplied} total applied</span>
          </div>
          <div className="funnel-list">
            {MOCK_STAGES.map((stage) => (
              <div className="funnel-row" key={stage.key}>
                <p className="funnel-label">{stage.label}</p>
                <div className="funnel-bar-track">
                  <div
                    className="funnel-bar-fill"
                    style={{ width: `${(stage.count / maxStageCount) * 100}%`, background: stage.color }}
                  />
                </div>
                <p className="funnel-count">{stage.count}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="job-insights-card job-insights-feed">
        <div className="job-insights-card-head">
          <h4>Recent activity</h4>
        </div>
        <div className="job-insights-feed-list">
          {MOCK_FEED.map((item) => (
            <div key={item.id} className="feed-items">
              <div className="icon" style={{ background: item.bg }}>
                <img src={item.icon} alt="" />
              </div>
              <div className="feed-text">
                <p className="feed-time">{item.time}</p>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JobInsightsV2;
